import dayjsGenerateConfig from 'bonree-picker/lib/generate/dayjs';
import generateCalendar, { CalendarProps } from './generateCalendar';
const Calendar = generateCalendar(dayjsGenerateConfig);
export { CalendarProps };
export default Calendar;
